var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5z",
    stroke: "#FF7534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82 10.043h2.127v7.41H6.82v-7.41zm1.01-.926h-.016c-.77 0-1.269-.567-1.269-1.284 0-.732.514-1.288 1.3-1.288.784 0 1.266.554 1.281 1.286 0 .717-.497 1.286-1.296 1.286zm9.625 8.337h-2.412V13.62c0-1.004-.377-1.688-1.206-1.688-.634 0-.987.462-1.151.908-.062.16-.052.382-.052.605v4.01h-2.389s.03-6.793 0-7.41h2.389v1.162c.14-.508.904-1.234 2.122-1.234 1.511 0 2.698 1.067 2.698 3.361v4.121z",
    fill: "#FF7534"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.167bc5e5d0c4a25b0c650ec56a6bba4b.svg";
export { ForwardRef as ReactComponent };